import { HOOPS_DEFAULT_FACE_COLOR_RGB as r, HOOPS_DEFAULT_LINE_COLOR_RGB as l, MM_IN_INCH as c } from "./HoopsViewer.consts.mjs";
const w = (n, t, e) => {
  const { t: i, i18n: o } = n;
  return typeof i == "function" && o && o.exists && o.exists(t) ? i(t) : e;
}, M = (n) => async () => {
  const { viewer: t, API: e, bundle: i, cb: o } = n, a = e.getFileType(), s = a === Communicator.FileType.Dwg || a === i.FileType.Dxf ? i.ViewOrientation.Front : i.ViewOrientation.Iso;
  await t.view.setViewOrientation(s, 0), e.customizeZoom(), await e.setShowNavCube(!0), await e.setShowAxisTriad(!0), await e.setColor({ face: r, line: l }), o && o();
}, f = () => (n) => {
  const t = n.getMeasurementValue() * n.getUnitMultiplier(), e = t / c;
  n.setMeasurementText(`${e.toFixed(3)} in | ${t.toFixed(1)} mm`);
}, O = (n) => (t, e, i) => {
  const { cb: o } = n;
  console.info(`HoopsViewer: Model [${t || "unnamed"}] load failure: ${e || "no reason"}`), i && console.error(i), o && o(t, e, i);
};
export {
  f as handleMeasurementValueSet,
  O as handleModelLoadFailure,
  M as handleModelStructureReady,
  w as translate
};
//# sourceMappingURL=HoopsViewer.utils.mjs.map
